import { Inbox, Loader2 } from "lucide-react";

export function EmptyState({ icon, title, hint, action, testid = "empty-state" }) {
  return (
    <div data-testid={testid} className="border border-dashed border-border rounded-2xl p-12 text-center">
      <div className="mx-auto mb-4 h-12 w-12 grid place-items-center rounded-xl bg-secondary text-muted-foreground">
        {icon || <Inbox className="h-5 w-5" />}
      </div>
      <p className="font-display font-semibold">{title}</p>
      {hint && <p className="text-sm text-muted-foreground mt-1 max-w-sm mx-auto">{hint}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function LoadingState({ rows = 3, testid = "loading-state" }) {
  return (
    <div data-testid={testid} className="space-y-3">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="rounded-2xl border border-border bg-card p-5">
          <div className="h-4 w-1/3 rounded bg-secondary animate-pulse" />
          <div className="mt-3 h-3 w-2/3 rounded bg-secondary/70 animate-pulse" />
        </div>
      ))}
    </div>
  );
}

export function Spinner({ label = "Laddar…" }) {
  return (
    <div className="flex items-center gap-2 text-sm text-muted-foreground">
      <Loader2 className="h-4 w-4 animate-spin" /> {label}
    </div>
  );
}
